// Put your applicaiton javascript here

let storefrontToken = "f7618ccd8cafe56bc30f833b10ef07b7";
if (location.origin.indexOf('dev') >= 0) {
  storefrontToken = "963bf0b7a0ff97f2d945c999d8c8fbc0";
}
if (location.origin.indexOf('imooore') >= 0) {
  storefrontToken = "a84b0560bdc186f76281a8c27e89e5ba";
}


theme.CartProductRecommendations = (function () {
  const selectors = {
    "cardProductRecommendations": ".card-product-recommendations",
    "productsList": ".card-product-recommendations .grid--view-items"
  };

  function CartProductRecommendations(container) {
    // console.log("CartProductRecommendations:", container, arguments);
    this.$container = $(container);
    this.$cardProductRecommendations = this.$container.find(selectors.cardProductRecommendations);
    this.$productsList = this.$container.find(selectors.productsList);
    const collectionHandle = this.collectionHandle = this.$cardProductRecommendations.data("collection");
    const productCounts = this.productCounts = this.$cardProductRecommendations.data("product-count");
    const money = this.money = this.$cardProductRecommendations.data("money");
    if (collectionHandle) {
      this.init({collectionHandle, productCounts});
    }
  }

  CartProductRecommendations.prototype = _.assignIn({}, CartProductRecommendations.prototype, {
    init: function ({collectionHandle, productCounts}) {
      graphql({
        query: `
{
  collectionByHandle(handle: "${collectionHandle}") {
    id
    products(first: ${productCounts}) {
      edges {
        node {
          id
          title
          onlineStoreUrl
          availableForSale
          variants(first: 1) {
            edges {
              node {
                available
                compareAtPrice
                price
                title
                image {
                  id
                  altText
                  originalSrc
                  src
                }
              }
            }
          }
        }
      }
    }
  }
}
`
      }).then(res => {
        const {data: {collectionByHandle: {products: {edges: list}}}} = res || {};

        const prods = _.map(list, item => {
          const {
            node: {
              id,
              title,
              onlineStoreUrl,
              availableForSale,
              variants: {edges: [{node: {price, compareAtPrice, image}}]}
            }
          } = item || {};
          return {id, title, onlineStoreUrl, availableForSale, price, compareAtPrice, image}
        })

        // console.log("CartProductRecommendations: ", collectionHandle, prods);
        if (prods.length > 0) {
          this.renderProducts(prods);
          this.$cardProductRecommendations.show();
        }
      })
    },
    renderProducts: function (products) {
      _.forEach(products, product => {
        this.$productsList.append(` <li class="grid__item small--one-half medium-up--one-quarter">
          ${this.renderProduct(product)}
        </li>`);
      });
    },

    renderProduct: function (product) {
      const {id, title, availableForSale, onlineStoreUrl, image, price, compareAtPrice} = product || {};
      const {src: preview_image} = image || {};
      const off = Math.floor(100 - price / compareAtPrice * 100);

      return `
<div class="grid-view-item ${availableForSale || "grid-view-item--sold-out"} product-card text-center">
  <a class="grid-view-item__link grid-view-item__image-container full-width-link"
     href="${onlineStoreUrl}">
     <span class="visually-hidden">${title}</span>
  </a>

  <div class="product-card__image-with-placeholder-wrapper" data-image-with-placeholder-wrapper>
    <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
      <div style="padding-top:100%;">
        <div class="grid-view-item__image box ratio-container lazyload js"
             data-bgset="${preview_image}"
             data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
             data-sizes="auto"
             data-parent-fit="cover"
             style="background-image: url('${preview_image}')">
        </div>
      </div>
    </div>
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder></div>
  </div>

  <div class="h3 grid-view-item__title product-card__title ellipsis" aria-hidden="true">${title}</div>

  <div class="grid-view-item__price-column">
    <dl class="price price--listing 
      ${availableForSale || " price--sold-out"}
      ${compareAtPrice > price && " price--on-sale"}"
    >
      <div class="price__regular">
        <dd>
          <span class="price-item price-item--regular">${this.renderMoney(price)}</span>
        </dd>
      </div>
      <div class="price__sale">
        <dd>
          <span class="price-item price-item--sale">${this.renderMoney(price)}</span>
        </dd>
        <div class="price__compare">
          <dd>
            <s class="price-item price-item--regular">
              ${this.renderMoney(compareAtPrice)}
            </s>
          </dd>
        </div>
      </div>
      <div class="price__unit">
      </div>
      <div class="price__badges price__badges--listing">
        <span class="price__badge price__badge--sale" aria-hidden="true">
           <span>${off}% OFF</span>
         </span>
        <span class="price__badge price__badge--sold-out">
           <span>SOLD OUT</span>
         </span>
       </div>
    </dl>
  </div>
</div>
    `
    },

    renderMoney: function (price) {
      return String(this.money).replace('0.00', price);
    }
  });

  return CartProductRecommendations;
})();


theme.AnnouncementBar = (function () {
  const selectors = {
    "announcementBar": ".announcement-bar",
    "messageList": ".announcement-bar__message-list",
    "messageListItem": ".announcement-bar__message-list-item"
  };
  const settings = {
    interval: 3000, //通知滚动间隔
    currentClass: 'current',
  };

  function AnnouncementBar(container) {
    this.$container = $(container);
    this.$announcementBar = this.$container.find(selectors.announcementBar);
    this.$messageList = this.$container.find(selectors.messageList);
    this.$messageListItems = this.$messageList.find(selectors.messageListItem);

    const section_settings_interval = this.$announcementBar.data("interval");
    this.options = {
      total: this.$messageListItems.length,
      currentIndex: 0,
      interval: section_settings_interval ? section_settings_interval * 1000 : settings.interval,
    }
    if (this.options.total > 0) {
      this.init();
    }
  }

  AnnouncementBar.prototype = _.assignIn({}, AnnouncementBar.prototype, {
    init: function () {
      setInterval(this.toNext.bind(this), this.options.interval || 3000);
    },
    toNext: function () {
      const {currentIndex, total} = this.options;
      let next = currentIndex + 1;
      if (next > total) {
        next = 0;
      }

      //console.log("AnnouncementBar goto !", next);

      $(this.$messageListItems[next]).addClass(settings.currentClass).siblings().removeClass(settings.currentClass);
      this.options.currentIndex = next;
    },
  })

  return AnnouncementBar;
})()

theme.Popup = (function () {
  const selectors = {
    "popup": ".popup",
    "moreBtn": ".popup__more .btn",
    "closeBtn": "[data-close]",
  };
  const classes = {
    openClass: 'open',
  };

  function Popup(container) {
    this.$body = $('body');
    this.$container = $(container);
    this.$popup = this.$container.find(selectors.popup);
    this.$moreBtn = this.$container.find(selectors.moreBtn);
    this.$closeBtn = this.$container.find(selectors.closeBtn);

    this.settings = this.$popup.data();

    this.$moreBtn.on('click', this.close.bind(this));
    this.$closeBtn.on('click', this.close.bind(this));
    this.show()
  }

  Popup.prototype = _.assignIn({}, Popup.prototype, {
    needShow: function () {
      if (this.settings.silenceDays > 0) {
        const lastTime = window.localStorage.getItem("last_popup_close_time");
        if (!lastTime) {
          return true;
        }
        if (Date.now() - lastTime > (1000 * 60 * 60 * 24)) {
          return true;
        }
        return false;
      }
      return true;
    },
    show: function () {
      if (this.needShow()) {
        this.$body.css({overflow: 'hidden'})
        this.$popup.appendTo(this.$body).addClass(classes.openClass);
      }
    },
    close: function () {
      this.$body.css({overflow: 'auto'});
      this.$popup.removeClass(classes.openClass);
      window.localStorage.setItem("last_popup_close_time", Date.now());
    }
  })

  return Popup;
})()

theme.ProductToolbar = (function () {
  const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    loader: '[data-loader]',
    loaderStatus: '[data-loader-status]',

    actionContainer: '.action',
    tabContents: '.product-single__description_tab_content'
  };
  const classes = {
    hidden: 'hide',
  };

  function ProductToolbar(container) {
    this.selectors = selectors;
    this.classes = classes;
    this.$container = $(container);
    this.$actionContainer = $(this.selectors.actionContainer, this.$container);
    this.$tabContents = $(this.selectors.tabContents);
    this.$targetForm = $("form[action='/cart/add']");
    this.$targetFormSubmitBtn = $('.product-form__cart-submit', this.$targetForm);
    this.$scrollTarget = $('.product-single__detail');

    this.productRecommendationsPosition = $("[data-product-recommendations-position]").data("productRecommendationsPosition");

    var fixPosition = this.$container.data("fixPosition");
    var fixPositionSmall = this.$container.data("fixPositionSmall");
    $('body').attr('data-product-toolbar-fix-position', fixPosition).attr('data-product-toolbar-fix-position-small', fixPositionSmall);

    this._initTabs();
    if (this.$scrollTarget.length > 0) {
      this._bindScroll();
    }
    setTimeout(this._setMargin.bind(this), 1000);
    setTimeout(this._setMargin.bind(this), 3000);
  }

  ProductToolbar.prototype = _.assignIn({}, ProductToolbar.prototype, {
    _setMargin: function () {
      if (!this.ready) {
        var productRecommendationsPosition = $("[data-product-recommendations-position]").data("productRecommendationsPosition");

        if (productRecommendationsPosition === 'left') {
          $(".product-single__toolbar .tabs").css("marginLeft", 330);
        } else if (productRecommendationsPosition) {
          $(".product-single__toolbar .tabs").css("marginLeft", 0);
        }

        if (productRecommendationsPosition !== undefined) {
          this.ready = true
        }
      }
    },
    _initTabs: function () {
      var _this = this;
      _this.$tabs = $('.tabs a', _this.$container);
      _this.$tabs.on('click', function (e) {
        e.preventDefault();
        var $tab = $(e.target);
        var href = $tab.attr('href');
        _this.$tabs.removeClass('active-tab');
        $('.tabs a.active-tab').removeClass('active-tab');
        _this.$tabContents.hide();
        $tab.addClass('active-tab');
        $(`.tabs a[href='${href}']`).addClass('active-tab');
        $(href).show();

        var top = _this.$scrollTarget.offset().top;
        document.documentElement.scrollTop = top;
      })
    },
    _bindScroll: function () {
      var onScroll = this._onScroll;
      $(document).scroll(
        $.debounce(250, onScroll.bind(this))
      );
    },
    _onScroll: function (e) {
      var top = this.$scrollTarget.offset().top;
      if (document.documentElement.scrollTop > (top - 5)) {
        this._setMargin();
        this._show()
      } else {
        $(".product-single__toolbar").removeClass("opened");
        this._hide()
      }
    },
    _show: function () {
      if (this.$container.find('.product-form__cart-submit').length <= 0) {
        var _this = this;
        var $btn = _this.$targetFormSubmitBtn.clone();
        this.$shopifyPaymentButton = $btn;
        this.$addToCart = $(this.selectors.addToCart, this.$container);
        this.$addToCartText = $(this.selectors.addToCartText, $btn);
        this.$loader = $(this.selectors.loader, $btn);

        this.$targetForm.on('beforesubmit', function () {
          _this._handleButtonLoadingState(true);
        })
        this.$targetForm.on('aftersubmit', function () {
          _this._handleButtonLoadingState(false);
        })
        $btn.click(function (e) {
          e.preventDefault();
          _this.$targetFormSubmitBtn.click();
        })
        $btn.appendTo(this.$actionContainer);
      }
      $(".product-single__toolbar").addClass("opened");
      $('body').addClass('product-single__toolbar-opened');
    }
    ,
    _hide: function () {
      $(".product-single__toolbar").removeClass("opened");
      $('body').removeClass('product-single__toolbar-opened');
    },
    _handleButtonLoadingState: function (isLoading) {
      if (isLoading) {
        this.$addToCart.attr('aria-disabled', true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr('disabled', true);
      } else {
        this.$addToCart.removeAttr('aria-disabled');
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr('disabled');
      }
    },
  })

  return ProductToolbar;
})()

theme.Reviews = (function () {
  function Reviews(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.$container = $container;
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      sectionId: sectionId,
    };
    this.selectors = {
      reviewThumbs: '.imooore-reviews__thumbnails-' + sectionId,
      reviewThumbsWrapper: '.imooore-reviews__thumbnails-wrapper',
      reviewThumbListItem: '.imooore-reviews__thumbnails-item',
      reviewThumbsPrevBtn: '.imooore-reviews__thumbnails-prev',
      reviewThumbsNextBtn: '.imooore-reviews__thumbnails-next',
    }
    this._initThumbnailSlider();
  }

  Reviews.prototype = _.assignIn({}, Reviews.prototype, {
    _initThumbnailSlider: function () {
      var self = this;
      var $reviewThumbs = $(self.selectors.reviewThumbs, self.$container);
      var $reviewThumbsWrapper = $reviewThumbs.parents(self.selectors.reviewThumbsWrapper);

      var thumbsWidth = $reviewThumbs.width();
      var parentWidth = $reviewThumbs.parent().width();
      // $reviewThumbs.css( "transform",  `translateX(${(thumbsWidth - parentWidth) / -2}px)`);
      const $prev = $reviewThumbsWrapper.find(self.selectors.reviewThumbsPrevBtn);
      const $next = $reviewThumbsWrapper.find(self.selectors.reviewThumbsNextBtn);
      if (thumbsWidth > parentWidth) {
        var minOffset = 0;
        var maxOffset = thumbsWidth - parentWidth;
        var setOffset = function (offset) {
          if (offset < minOffset) {
            offset = minOffset;
          }
          if (offset > maxOffset) {
            offset = maxOffset;
          }
          $reviewThumbs.data("offset", offset);
          $reviewThumbs.css("transition", "transform .2s ease 0s")
          $reviewThumbs.css("transform", `translateX(${offset * -1}px)`);
        }
        $prev.on('click', function () {
          var offset = $reviewThumbs.data("offset") - 200;
          setOffset(offset)
        }).show();
        $next.on('click', function () {
          var offset = $reviewThumbs.data("offset") + 200;
          setOffset(offset)
        }).show();
        setOffset(maxOffset / 2);

      } else {
        $prev.hide();
        $next.hide()
      }
    }
  })
  return Reviews;
})()

$(document).ready(function () {
  function query(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        headers: {
          "content-type": "application/json; charset=utf-8",
          "X-Shopify-Storefront-Access-Token": storefrontToken
        },
        url: "/api/2020-07/graphql.json",
        async: false,
        data: JSON.stringify({...data}),
        success: resolve,
        error: reject,
      });
    })
  }

  window.graphql = query;


  const sections = new theme.Sections();
  sections.register('cart-template', theme.CartProductRecommendations);
  sections.register('header-section', theme.AnnouncementBar);
  sections.register('popup-section', theme.Popup);
  sections.register('product-toolbar', theme.ProductToolbar);
  sections.register('page-reviews', theme.Reviews);
})


function scrollTo(ele, speed) {
  if (!speed) speed = 300;
  if (!ele) {
    $("html,body").animate({scrollTop: 0}, speed);
  } else {
    if (ele.length > 0)
      $("html,body").animate({scrollTop: $(ele).offset().top}, speed);
  }
  return false;
}


$(document).ready(function () {
  const $doc = $(document);
  const $back = $(".back-to-top-button");
  $back.click(function (e) {
    e.stopPropagation();
    scrollTo();
  })
  $doc.scroll(
    $.debounce(250, function (e) {
      if ($(e.target).scrollTop() > $(window).height()) {
        $back.appendTo($("body")).show('fast');
      } else {
        $back.hide('fast');
      }
    })
  )
});
